import { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Swap this one line if the date ever changes:
export const EVENT_DATE = "2027-01-30T10:00:00+01:00"; // Saturday 30 January 2027, 10:00 AM WAT
const EVENT_LABEL = "Saturday, 30 January 2027 · Aurora Conference Centre, Osogbo";

const UNITS = [
  { key: "days", label: "Days" },
  { key: "hours", label: "Hours" },
  { key: "minutes", label: "Minutes" },
  { key: "seconds", label: "Seconds" },
];

function diffParts(target) {
  const diff = Math.max(0, target - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
  };
}

export default function Countdown() {
  const target = new Date(EVENT_DATE).getTime();
  const [parts, setParts] = useState(() => diffParts(target));

  useEffect(() => {
    const id = setInterval(() => setParts(diffParts(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: 1.25, ease: [0.16, 1, 0.3, 1] }}
      data-testid="hero-countdown"
    >
      <div className="cd-title">The arena opens in</div>
      <div className="countdown">
        {UNITS.map((u) => (
          <div className="cd-box" key={u.key} data-testid={`cd-${u.key}`}>
            <motion.span
              className="cd-num"
              key={parts[u.key]}
              initial={{ opacity: 0.3, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35 }}
            >
              {String(parts[u.key]).padStart(2, "0")}
            </motion.span>
            <span className="cd-label">{u.label}</span>
          </div>
        ))}
      </div>
      <p className="cd-note">Target: {EVENT_LABEL}</p>
    </motion.div>
  );
}
